export default {
  title: 'Connexion avec SSO',
  subtitle:
    'Entrez votre email professionnel pour continuer avec Single Sign-On',
  continueButton: 'Continuer avec SSO',
  errors: {
    noSsoConfiguration:
      "Aucune configuration SSO n'a été trouvée pour ce domaine email. Veuillez contacter votre administrateur."
  }
};
